import * as React from 'react';
import { connect } from 'react-redux';

import { FromToControl } from '../../../../common/components/from_to_control';
import { IAppState, Dispatch } from '../../../../common/state';
import { IJsonQueryRange } from '../../../../json_query';
import { FOfferType, isCommercial } from '../../../../utils/category';
import { changeMaxFloorsTotal, changeMinFloorsTotal } from '../../../state/advanced/floors_total';
import { InlineBlock, Row } from '../markup';

const STAGE_MAX_LENGTH = 4;
export interface IFloorsTotalProps {
  offerType: FOfferType;

  floorsTotal: IJsonQueryRange | undefined;
  onMinFloorsTotalChanged(value: number | undefined): void;
  onMaxFloorsTotalChanged(value: number | undefined): void;
}

export const floorsTotal: React.StatelessComponent<IFloorsTotalProps> = props => (
  <Row title={`Этажей в ${!isCommercial(props.offerType) ? 'доме' : 'здании'}`}>
    <InlineBlock>
      <FromToControl
        rangeGroupStyle={{ width: 120 }}
        from={{
          value: props.floorsTotal && props.floorsTotal.value.gte,
          placeholder: 'от',
          onValueChange: props.onMinFloorsTotalChanged,
          maxLength: STAGE_MAX_LENGTH,
        }}
        to={{
          value: props.floorsTotal && props.floorsTotal.value.lte,
          placeholder: 'до',
          onValueChange: props.onMaxFloorsTotalChanged,
          maxLength: STAGE_MAX_LENGTH,
        }}
      />
    </InlineBlock>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect<
  {
    floorsTotal: IJsonQueryRange | undefined;
  },
  {
    onMinFloorsTotalChanged(value: number | undefined): void;
    onMaxFloorsTotalChanged(value: number | undefined): void;
  },
  {
    offerType: FOfferType;
  }
>(
  (state: IAppState) => ({
    floorsTotal: state.filters.jsonQuery.floorn,
  }),
  (dispatch: Dispatch) => ({
    onMinFloorsTotalChanged: (value: number | undefined) => {
      dispatch(changeMinFloorsTotal(value));
    },
    onMaxFloorsTotalChanged: (value: number | undefined) => {
      dispatch(changeMaxFloorsTotal(value));
    },
  }),
)(floorsTotal);
